var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
/**
 * A linear loading indicator that shows activity or ongoing processes.
 *
 * @example
 * ```html
 * <kr-progress-bar></kr-progress-bar>
 * <kr-progress-bar color="light"></kr-progress-bar>
 * <kr-progress-bar color="#ff5500"></kr-progress-bar>
 * <kr-progress-bar color="#ff5500" trackColor="#eeeeee"></kr-progress-bar>
 * ```
 */
export class KRProgressBar extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * The color of the progress bar. Can be 'dark', 'light', or any valid CSS color value.
         */
        this.color = 'dark';
    }
    render() {
        let normalizedColor = '';
        let normalizedTrackColor = '';
        if (this.color === 'dark') {
            normalizedColor = '#163052';
        }
        else if (this.color === 'light') {
            normalizedColor = '#ffffff';
        }
        else {
            normalizedColor = this.color;
        }
        if (this.trackColor) {
            normalizedTrackColor = this.trackColor;
        }
        else if (this.color === 'light') {
            normalizedTrackColor = '#ffffff4d';
        }
        else {
            normalizedTrackColor = '#0000001a';
        }
        return html `
      <div
        class="progress-bar"
        style=${styleMap({ background: normalizedTrackColor })}
        role="status"
        aria-label="Loading"
      >
        <div class="fill" style=${styleMap({ background: normalizedColor })}></div>
      </div>
    `;
    }
}
KRProgressBar.styles = css `
    :host {
      display: block;
      width: 100%;
      overflow: hidden;
    }

    .progress-bar {
      position: relative;
      height: 4px;
      border-radius: 2px;
      overflow: hidden;
    }

    /* Fill (primary indicator) */
    .fill {
      position: absolute;
      top: 0;
      height: 100%;
      width: 40%;
      border-radius: inherit;
      animation: indeterminate 1.5s ease-in-out infinite;
    }

    @keyframes indeterminate {
      0% {
        left: -40%;
      }
      100% {
        left: 100%;
      }
    }
  `;
__decorate([
    property({
        type: String,
        reflect: true,
    })
], KRProgressBar.prototype, "color", void 0);
__decorate([
    property({
        type: String,
        reflect: true,
    })
], KRProgressBar.prototype, "trackColor", void 0);
// Guarded registration: no-op if the tag is already defined, so a second copy of krubble on
// the page (e.g. the Operations shell loads krubble globally while an embedded app bundled its
// own copy) doesn't throw. First definition wins.
if (!customElements.get('kr-progress-bar')) {
    customElements.define('kr-progress-bar', KRProgressBar);
}
//# sourceMappingURL=progress-bar.js.map